import React from 'react'
import clsx from 'clsx'
import kebabCase from 'lodash.kebabcase'

import { Image } from '@/components/atoms/Image/Image'
import { CustomLink } from '@/components/atoms/CustomLink/CustomLink'
import { SectionCustomerStoriesProps } from './types'

export function SectionCustomerStories({ heading, stories }: SectionCustomerStoriesProps) {
  return (
    <section className={clsx('bg-center relative bg-primary-100')} id={kebabCase(heading)}>
      <div
        className="flex flex-col px-24 py-48 gap-24 netbook:gap-48 mx-auto
    laptop:px-90  netbook:py-64 max-w-screen-desktop"
      >
        <h2 className="text-headingM-mobile text-text-dark-900 netbook:text-headingM font-poppins">{heading}</h2>
        {stories && stories.length > 0 && (
          <div className="flex flex-col netbook:flex-row netbook:justify-between w-full netbook:gap-24">
            {stories?.map((story) => {
              const card = story.content
              if (!card) return null
              return (
                <CustomLink
                  link_url={{
                    cached_url: story.full_slug,
                    url: '',
                    id: story.full_slug,
                    fieldtype: '',
                    linktype: ''
                  }}
                  is_external={false}
                  new_tab={false}
                  className="flex-1 first:pt-0 py-16 last:pb-0 first:border-b-1 last:border-t-1 border-b-solid border-primary-500/30 netbook:border-none netbook:py-0 netbook:max-w-[403px]"
                >
                  <article className="flex flex-row items-center netbook:items-start netbook:flex-col gap-16">
                    {card.card_image && (
                      <Image
                        fixed={false}
                        fluid
                        data={card.card_image}
                        className="min-w-156 mobile:min-w-192 aspect-[1.5] rounded-[5px] netbook:w-full"
                      />
                    )}
                    <div className="text-text-dark-900 font-sans flex flex-col gap-16">
                      {card.card_title && (
                        <p className="text-bodyS netbook:text-bodyL font-bold font-poppins netbook:line-clamp-3">
                          {card.card_title}
                        </p>
                      )}
                      {card.card_teaser && <p className="hidden text-bodyM netbook:line-clamp-3">{card.card_teaser}</p>}
                    </div>
                  </article>
                </CustomLink>
              )
            })}
          </div>
        )}
      </div>
    </section>
  )
}
